export const appConstants = {
	CLIENT_ID_SECRET: '',

	LOCAL_STORAGE: {
		ACCESS_TOKEN: 'access-token',
		REFRESH_TOKEN: 'refresh-token',
	},

	PATTERNS: {
		PASSWORD: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[~`!@#$%^&*()+=_\{\}\\-\\:;”’\[\]\|?/<>,.])(?!.*\s).{8,100}$/,
		TRUE_VALUE: '^true$',
		ONLY_LETTERS: /^[A-Za-z]+$/,
		NAME_VALIDATOR: /^[a-zA-Z\s\.&-]+$/,
		FULL_NUMBERS: '^[0-9]*$',
		LETTERS_AND_NUMBERS: '^[A-Za-z0-9]+$',
		DECIMAL_NUMBERS: '^[0-9]+(.[0-9]{1,2})?$',
		// EMAIL:  /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/,
		EMAIL: /^((\".+?\"@)|(([0-9a-z]((\.(?!\.))|[\w])*)@))((\[(\d{1,3}\.){3}\d{1,3}\])|(([0-9a-z][-0-9a-z]*[0-9a-z]*\.)+[a-z0-9][\-a-z0-9]{0,22}[a-z0-9]))$/,
		ACCOUNT_NUMBER: '^[A-Z0-9]+$',
		IBAN: /^[A-Z]{2}[A-Z0-9]{2,38}$/,
		SWIFT: '^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$',
		PHONE_NUMBER: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/,
		NUMBER_PATTERN: /\d+/g,
		COMPANY: /^[a-zA-Z0-9&]+(\s+[a-zA-Z0-9&]+)*/,
		POSITION: /^[a-zA-Z]+(\s+[a-zA-Z]+)*$/,
		DOMAIN: '^[a-z0-9]+[\.]+([a-z0-9]+)+$',
	},

	QUERY_PARAMS: {
		RESET_HASH: 'resetHash',
		PAGE_SIZE: 'PageSize',
		CURRENT_PAGE: 'CurrentPage',
		ROLE_ID: 'RoleId',
		COMPANY_ID: 'CompanyId',
		STATUS: 'status',
		LICENSE_PLATE: 'LicensePlate',
		BRAND: 'BrandName',
		MODEL: 'Model',
		VARIANT: 'Variant',
		YEAR: 'ProductionYear',
		REASON: 'reason',
		SUBSCRIPTION: 'subscription',
		SUBSCRIPTION_STATUS: 'SubscriptionStatus',
		COMPANY_NAME: 'CompanyName',
		ROLE_IDS: 'RoleIds',
		PAYMENT_STATUS: 'PaymentStatus',
		REFERENCE_NUMBER: 'ReferenceNumber',
		SUBSCRIPTION_ID: 'SubscriptionId',
		SUBSCRIPTION_START_DATE: 'SubscriptionStartDate',
		PLANNED_END_DATE: 'PlannedEndDate',
		FULL_NAME: 'FullName',
		FROM_DATE: 'FromDate',
		TO_DATE: 'ToDate',
		START_DATE: 'StartDate',
		END_DATE: 'EndDate',
		START_FROM_DATE: 'StartFromDate',
		START_TO_DATE: 'StartToDate',
		DATE_CREATED_START: 'DateCreatedStart',
		DATE_CREATED_END: 'DateCreatedEnd',
		INVOICE_NUMBER: 'InvoiceNumber',
		PAYMENT_TYPE: 'PaymentType',
		UNIQUE_IDENTIFIER: 'UniqueIdentifier',
		CHARGE_TYPE: 'ChargeType',
		SUBSCRIPTION_REF_NUMBER: 'SubscriptionRefNumber',
		VENDOR_INVOICE: 'VendorInvoice',
		NAME: 'Name',
		LENGTH: 'length',
		CUSTOMER_ID: 'CustomerId',
		NUMBER_OF_INTERVALS: 'NumberOfIntervals',
		EXTENSION_TYPE: 'ExtensionType',
		INCLUDE_FINAL_dAY: 'IncludeFinalDay',
	},

	DATE_FORMAT: 'YYYY-MM-DDTHH:mm:ss',
	DISPLAY_DATE: 'DD-MM-YYYY, hh:mmA',
	ACTIVATION_CODE_DATE_FORMAT: 'YYYY-MM-DDTHH:mm:ss.SSS',

	//DISPLAY_DATE: 'DD-MM-YYYY, hh:mm a ZZ',

	MAX_WINDOW_WIDTH: 990,

	DOCUMENT_REQUIREMENTS: {
		MAX_SIZE: 5000000, // size in bytes; this is equal to 5mb
		ALLOWED_FILE_TYPES: ['jpg', 'png', 'pdf'],
		FORBIDDEN_FILE_TYPES: [
			//
			'asp',
			'aspx',
			'pl',
			'php',
			'cgi',
			'asa',
			'htaccess',
			'exe',
			'bat',
		],
	},

	MANUAL_CHARGE_DOCUMENT_REQUIREMENTS: {
		MAX_SIZE: 5000000, // size in bytes; this is equal to 5mb
		ALLOWED_FILE_TYPES: ['jpg', 'png', 'pdf', 'xls', 'xlsx'],
		FORBIDDEN_FILE_TYPES: [
			//
			'asp',
			'aspx',
			'pl',
			'php',
			'cgi',
			'asa',
			'htaccess',
			'exe',
			'bat',
		],
	},

	IMAGE_REQUIREMENTS: {
		MAX_SIZE: 5000, // size in kb; this is equal to 1mb,
		MAX_IMAGES: 6,
		ALLOWED_FILE_TYPES: [
			//
			'image/png',
			'image/jpeg',
			'image/bmp',
			'image/jpg',
		],
	},

	MODEL_REQUIREMENTS: {
		MIN_NAME_VARIANT_STRING_LENGTH: 1,
		MIN_STRING_LENGTH: 2,
		MAX_STRING_LENGTH: 200,
		MAX_ENGINE_SIZE: 100000,
		MAX_DOORS: 7,
		MIN_YEAR: 1800,
		MAX_YEAR: 2500,
		MAX_SEATING_CAPACITY: 200,
		MAX_LUGGAGE_CAPACITY: 600,
		MIN_NUMBER: 1,
		MIN_SERVICE_INTERVAL: 1000,
		MAX_SERVICE_INTERVAL: 20000,
		SERVICE_INTERVAL_STEP: 1000,
		MAX_FUEL: 500,
	},

	COMPANY_DETAILS: {
		LEAD_TIME_MIN: 0,
		LEAD_TIME_MAX: 0,
		BANK_NAME_MIN_LENGTH: 2,
		BANK_NAME_MAX_LENGTH: 100,
	},

	COUNTRY_LIST: {
		AF: 'Afghanistan',
		AL: 'Albania',
		DZ: 'Algeria',
		AS: 'American Samoa',
		AD: 'Andorra',
		AO: 'Angola',
		AI: 'Anguilla',
		AQ: 'Antarctica',
		AG: 'Antigua and Barbuda',
		AR: 'Argentina',
		AM: 'Armenia',
		AW: 'Aruba',
		AU: 'Australia',
		AT: 'Austria',
		AZ: 'Azerbaijan',
		BS: 'Bahamas (the)',
		BH: 'Bahrain',
		BD: 'Bangladesh',
		BB: 'Barbados',
		BY: 'Belarus',
		BE: 'Belgium',
		BZ: 'Belize',
		BJ: 'Benin',
		BM: 'Bermuda',
		BT: 'Bhutan',
		BO: 'Bolivia (Plurinational State of)',
		BQ: 'Bonaire, Sint Eustatius and Saba',
		BA: 'Bosnia and Herzegovina',
		BW: 'Botswana',
		BV: 'Bouvet Island',
		BR: 'Brazil',
		IO: 'British Indian Ocean Territory (the)',
		BN: 'Brunei Darussalam',
		BG: 'Bulgaria',
		BF: 'Burkina Faso',
		BI: 'Burundi',
		CV: 'Cabo Verde',
		KH: 'Cambodia',
		CM: 'Cameroon',
		CA: 'Canada',
		KY: 'Cayman Islands (the)',
		CF: 'Central African Republic (the)',
		TD: 'Chad',
		CL: 'Chile',
		CN: 'China',
		CX: 'Christmas Island',
		CC: 'Cocos (Keeling) Islands (the)',
		CO: 'Colombia',
		KM: 'Comoros (the)',
		CD: 'Congo (the Democratic Republic of the)',
		CG: 'Congo (the)',
		CK: 'Cook Islands (the)',
		CR: 'Costa Rica',
		HR: 'Croatia',
		CU: 'Cuba',
		CW: 'Curaçao',
		CY: 'Cyprus',
		CZ: 'Czechia',
		CI: "Côte d'Ivoire",
		DK: 'Denmark',
		DJ: 'Djibouti',
		DM: 'Dominica',
		DO: 'Dominican Republic (the)',
		EC: 'Ecuador',
		EG: 'Egypt',
		SV: 'El Salvador',
		GQ: 'Equatorial Guinea',
		ER: 'Eritrea',
		EE: 'Estonia',
		SZ: 'Eswatini',
		ET: 'Ethiopia',
		FK: 'Falkland Islands (the) [Malvinas]',
		FO: 'Faroe Islands (the)',
		FJ: 'Fiji',
		FI: 'Finland',
		FR: 'France',
		GF: 'French Guiana',
		PF: 'French Polynesia',
		TF: 'French Southern Territories (the)',
		GA: 'Gabon',
		GM: 'Gambia (the)',
		GE: 'Georgia',
		DE: 'Germany',
		GH: 'Ghana',
		GI: 'Gibraltar',
		GR: 'Greece',
		GL: 'Greenland',
		GD: 'Grenada',
		GP: 'Guadeloupe',
		GU: 'Guam',
		GT: 'Guatemala',
		GG: 'Guernsey',
		GN: 'Guinea',
		GW: 'Guinea-Bissau',
		GY: 'Guyana',
		HT: 'Haiti',
		HM: 'Heard Island and McDonald Islands',
		VA: 'Holy See (the)',
		HN: 'Honduras',
		HK: 'Hong Kong',
		HU: 'Hungary',
		IS: 'Iceland',
		IN: 'India',
		ID: 'Indonesia',
		IR: 'Iran (Islamic Republic of)',
		IQ: 'Iraq',
		IE: 'Ireland',
		IM: 'Isle of Man',
		IL: 'Israel',
		IT: 'Italy',
		JM: 'Jamaica',
		JP: 'Japan',
		JE: 'Jersey',
		JO: 'Jordan',
		KZ: 'Kazakhstan',
		KE: 'Kenya',
		KI: 'Kiribati',
		KP: "Korea (the Democratic People's Republic of)",
		KR: 'Korea (the Republic of)',
		KW: 'Kuwait',
		KG: 'Kyrgyzstan',
		LA: "Lao People's Democratic Republic (the)",
		LV: 'Latvia',
		LB: 'Lebanon',
		LS: 'Lesotho',
		LR: 'Liberia',
		LY: 'Libya',
		LI: 'Liechtenstein',
		LT: 'Lithuania',
		LU: 'Luxembourg',
		MO: 'Macao',
		MG: 'Madagascar',
		MW: 'Malawi',
		MY: 'Malaysia',
		MV: 'Maldives',
		ML: 'Mali',
		MT: 'Malta',
		MH: 'Marshall Islands (the)',
		MQ: 'Martinique',
		MR: 'Mauritania',
		MU: 'Mauritius',
		YT: 'Mayotte',
		MX: 'Mexico',
		FM: 'Micronesia (Federated States of)',
		MD: 'Moldova (the Republic of)',
		MC: 'Monaco',
		MN: 'Mongolia',
		ME: 'Montenegro',
		MS: 'Montserrat',
		MA: 'Morocco',
		MZ: 'Mozambique',
		MM: 'Myanmar',
		NA: 'Namibia',
		NR: 'Nauru',
		NP: 'Nepal',
		NL: 'Netherlands (the)',
		NC: 'New Caledonia',
		NZ: 'New Zealand',
		NI: 'Nicaragua',
		NE: 'Niger (the)',
		NG: 'Nigeria',
		NU: 'Niue',
		NF: 'Norfolk Island',
		MP: 'Northern Mariana Islands (the)',
		NO: 'Norway',
		OM: 'Oman',
		PK: 'Pakistan',
		PW: 'Palau',
		PS: 'Palestine, State of',
		PA: 'Panama',
		PG: 'Papua New Guinea',
		PY: 'Paraguay',
		PE: 'Peru',
		PH: 'Philippines (the)',
		PN: 'Pitcairn',
		PL: 'Poland',
		PT: 'Portugal',
		PR: 'Puerto Rico',
		QA: 'Qatar',
		MK: 'Republic of North Macedonia',
		RO: 'Romania',
		RU: 'Russian Federation (the)',
		RW: 'Rwanda',
		RE: 'Réunion',
		BL: 'Saint Barthélemy',
		SH: 'Saint Helena, Ascension and Tristan da Cunha',
		KN: 'Saint Kitts and Nevis',
		LC: 'Saint Lucia',
		MF: 'Saint Martin (French part)',
		PM: 'Saint Pierre and Miquelon',
		VC: 'Saint Vincent and the Grenadines',
		WS: 'Samoa',
		SM: 'San Marino',
		ST: 'Sao Tome and Principe',
		SA: 'Saudi Arabia',
		SN: 'Senegal',
		RS: 'Serbia',
		SC: 'Seychelles',
		SL: 'Sierra Leone',
		SG: 'Singapore',
		SX: 'Sint Maarten (Dutch part)',
		SK: 'Slovakia',
		SI: 'Slovenia',
		SB: 'Solomon Islands',
		SO: 'Somalia',
		ZA: 'South Africa',
		GS: 'South Georgia and the South Sandwich Islands',
		SS: 'South Sudan',
		ES: 'Spain',
		LK: 'Sri Lanka',
		SD: 'Sudan (the)',
		SR: 'Suriname',
		SJ: 'Svalbard and Jan Mayen',
		SE: 'Sweden',
		CH: 'Switzerland',
		SY: 'Syrian Arab Republic',
		TW: 'Taiwan',
		TJ: 'Tajikistan',
		TZ: 'Tanzania, United Republic of',
		TH: 'Thailand',
		TL: 'Timor-Leste',
		TG: 'Togo',
		TK: 'Tokelau',
		TO: 'Tonga',
		TT: 'Trinidad and Tobago',
		TN: 'Tunisia',
		TR: 'Turkey',
		TM: 'Turkmenistan',
		TC: 'Turks and Caicos Islands (the)',
		TV: 'Tuvalu',
		UG: 'Uganda',
		UA: 'Ukraine',
		AE: 'United Arab Emirates (the)',
		GB: 'United Kingdom of Great Britain and Northern Ireland (the)',
		UM: 'United States Minor Outlying Islands (the)',
		US: 'United States of America (the)',
		UY: 'Uruguay',
		UZ: 'Uzbekistan',
		VU: 'Vanuatu',
		VE: 'Venezuela (Bolivarian Republic of)',
		VN: 'Viet Nam',
		VG: 'Virgin Islands (British)',
		VI: 'Virgin Islands (U.S.)',
		WF: 'Wallis and Futuna',
		EH: 'Western Sahara',
		YE: 'Yemen',
		ZM: 'Zambia',
		ZW: 'Zimbabwe',
		AX: 'Åland Islands',
	},

	PLACEHOLDERS: {
		SALIK: {
			FROM: 'From trip date',
			TO: 'To trip date',
		},
		TRAFFIC_FINES: {
			FROM: 'From fine date',
			TO: 'To fine date',
		},
		USERS: {
			FROM: 'From date registered',
			TO: 'To date registered',
		},
		RESERVATION_MANAGEMENT: {
			FROM: 'From created date',
			TO: 'To created date',
		},
		SUBSCRIPTION_MANAGEMENT: {
			FROM: 'From created date',
			TO: 'To created date',
		},
		PAYMENT_OVERVIEW: {
			FROM: 'From invoice creation date',
			TO: 'To invoice creation date',
		},
		MANUAL_CHARGES: {
			FROM: 'From charge date',
			TO: 'To charge date',
		},
		VALIDITY_PERIOD: {
			FROM: 'Validity period start',
			TO: 'Validity period end',
		},
	},
};
